export default __webpack_public_path__ + "static/8-2ed9c9037c44fa83cf1c2b960b1e1b2a.jpg";